import { render } from "./StockLocationList.vue?vue&type=template&id=564d6386"
import script from "./StockLocationList.vue?vue&type=script&lang=js"
export * from "./StockLocationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__